<template>
  <section>
    <b-button v-if="isModal"
      size="is-small"
      type="is-success"
      style="border-radius: 6px"
      outlined
      @click="isComponentModalActive = true"
      >登录</b-button
    >
    <b-modal v-if="isModal"
      v-model="isComponentModalActive"
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Example Modal"
      close-button-aria-label="Close"
      aria-modal
    >
      <div class="login-box">
        <div class="login-box-l"></div>
        <div class="login-box-r">
          <form
            style="width: 354px"
            method="POST"
            @submit.prevent="handleLogin"
          >
            <b-field
              style="height: 90px"
              label="账号"
              :message="usernameMessage"
            >
              <b-input
                v-model="loginForm.username"
                type="username"
                required
                placeholder="请输入用户名或邮箱"
                @blur="validateUsername"
              />
            </b-field>
            <b-field style="height: 90px" label="密码" :message="pwdMessage">
              <b-input
                v-model="loginForm.password"
                type="password"
                password-reveal
                required
                placeholder="请输入密码"
                @blur="validatePwd"
              />
            </b-field>
            <div>
              <b-field
                style="height: 90px"
                label="验证码"
                :message="codeMessage"
              >
                <b-input
                  v-model="loginForm.code"
                  type="code"
                  required
                  placeholder="请输入验证码"
                  @blur="validateCode"
                />
                <div
                  class="login-code"
                  style="
                    cursor: pointer;
                    margin-left: 5px;
                    height: 40px;
                    float: right;
                    background-color: #f0f1f5;
                  "
                >
                  <img
                    style="
                      width: 100%;
                      height: 40px;
                      border: 1px solid rgba(0, 0, 0, 0.1);
                      border-radius: 2px;
                    "
                    :src="codeUrl"
                    alt="yzm"
                    @click="getCode"
                  />
                </div>
              </b-field>
            </div>
            <div class="login-footer-btn">
              <b-button
                class="item-btn"
                label="取消"
                type="is-light"
                @click="isComponentModalActive = false"
              />
              <b-button
                class="item-btn"
                label="登录"
                type="is-primary"
                @click="handleLogin"
              />
            </div>
            <div style="display: flex;align-items: center;justify-content: space-between">
              <a
                class="login-zc"
                :href="signupUrl"
                target="_blank"
                rel="noopener noreferrer"
                has-text-black
              >点击注册>></a
              >
              <a
                class="login-zc"
                :href="forgetUrl"
                target="_blank"
                rel="noopener noreferrer"
                has-text-black
              >忘记密码?</a
              >
            </div>
          </form>
        </div>
      </div>
    </b-modal>
    <div class="login-box" v-else>
      <div class="login-box-l"></div>
      <div class="login-box-r">
        <form
          style="width: 354px"
          method="POST"
          @submit.prevent="handleLogin"
        >
          <b-field
            style="height: 90px"
            label="账号"
            :message="usernameMessage"
          >
            <b-input
              v-model="loginForm.username"
              type="username"
              required
              placeholder="请输入用户名或邮箱"
              @blur="validateUsername"
            />
          </b-field>
          <b-field style="height: 90px" label="密码" :message="pwdMessage">
            <b-input
              v-model="loginForm.password"
              type="password"
              password-reveal
              required
              placeholder="请输入密码"
              @blur="validatePwd"
            />
          </b-field>
          <div>
            <b-field
              style="height: 90px"
              label="验证码"
              :message="codeMessage"
            >
              <b-input
                v-model="loginForm.code"
                type="code"
                required
                placeholder="请输入验证码"
                @blur="validateCode"
              />
              <div
                class="login-code"
                style="
                    cursor: pointer;
                    margin-left: 5px;
                    height: 40px;
                    float: right;
                    background-color: #f0f1f5;
                  "
              >
                <img
                  style="
                      width: 100%;
                      height: 40px;
                      border: 1px solid rgba(0, 0, 0, 0.1);
                      border-radius: 2px;
                    "
                  :src="codeUrl"
                  alt="yzm"
                  @click="getCode"
                />
              </div>
            </b-field>
          </div>
          <div class="login-footer-btn">
            <b-button
              class="item-btn"
              label="取消"
              type="is-light"
              @click="isComponentModalActive = false"
            />
            <b-button
              class="item-btn"
              label="登录"
              type="is-primary"
              @click="handleLogin"
            />
          </div>

          <div style="display: flex;align-items: center;justify-content: space-between">
            <a
              class="login-zc"
              :href="signupUrl"
              target="_blank"
              rel="noopener noreferrer"
              has-text-black
            >点击注册>></a
            >
            <a
              class="login-zc"
              :href="forgetUrl"
              target="_blank"
              rel="noopener noreferrer"
              has-text-black
            >忘记密码?</a
            >
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { getCodeImg } from "@/api/login";
export default {
  props: {
    isModal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      signupUrl: process.env.VUE_APP_BBS_URL + "/user/signup",
      forgetUrl: process.env.VUE_APP_BBS_URL + "/user/forget",
      indefinteToast: "",
      codeUrl: "",
      isLoading: false,
      formValid: false,
      usernameMessage: "",
      usernameValid: false,
      pwdMessage: "",
      pwdValid: false,
      codeMessage: "",
      codeValid: false,
      isComponentModalActive: false,
      loginForm: {
        username: undefined,
        password: undefined,
        rememberMe: false,
        code: undefined,
        uuid: "",
      },
    };
  },
  created() {
    this.getCode();
    document.addEventListener('csCustomLoginEvent', (event)=> {
      this.isComponentModalActive = true
    }, {
      once: false
    });
  },
  methods: {
    getCode() {
      getCodeImg().then((res) => {
        if (res !== undefined) {
          this.codeUrl = res.data;
          this.loginForm.uuid = res.id;
        }
      });
    },
    validateUsername() {
      if (!this.loginForm.username) {
        this.usernameValid = false;
        this.usernameMessage = "账号不能为空";
      } else {
        this.usernameValid = true;
        this.usernameMessage = "";
      }
    },
    validatePwd() {
      if (!this.loginForm.password) {
        this.pwdValid = false;
        this.pwdMessage = "密码不能为空";
      } else {
        this.pwdValid = true;
        this.pwdMessage = "";
      }
    },
    validateCode() {
      if (!this.loginForm.code) {
        this.codeValid = false;
        this.codeMessage = "验证码不能为空";
      } else {
        this.codeValid = true;
        this.codeMessage = "";
      }
    },
    handleLogin(e) {
      if (!this.pwdValid || !this.usernameValid || !this.codeValid) {
        this.indefinteToast = this.$buefy.toast.open({
          duration: 3000,
          message: `请检查输入的账号、密码和验证码`,
          type: "is-warning",
        });
        return;
      }
      this.isLoading = true;
      this.$store
        .dispatch("login", this.loginForm)
        .then((res) => {
          this.isComponentModalActive = false;
          console.log("login success");
          this.$emit("loginSuccess");
          const okEvent = new CustomEvent('csCustomLoginSuccessEvent', {
            detail: {}, // 自定义事件的详细信息
            bubbles: true, // 事件是否冒泡
            cancelable: true // 事件是否可以被取消
          });
          document.dispatchEvent(okEvent);
        })
        .catch((err) => {
          this.isLoading = false;
          this.loginForm.code = ''
          // this.isComponentModalActive = false;
          this.getCode();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-zc {
  outline: none;
  color: #57aecc;
  font-size: 14px;
}
.login-footer-btn {
  display: flex;
  justify-content: space-between;
  padding: 20px 0 10px;
  box-sizing: border-box;
  .item-btn {
    flex: 1;
    &:first-child {
      margin-right: 20px;
    }
  }
}
.login-box-r {
  margin: 0 auto;
  text-align: left;
}
.login-box {
  width: 950px;
  height: 540px;
  background-color: #fff;
  display: flex;
  align-items: center;
  z-index: 1000;
  .login-box-l {
    width: 50%;
    height: 540px;
    background: url("../assets/login/login-bg.png") no-repeat center center;
    background-size: cover;
  }
}
.login-btn {
  cursor: pointer;
  width: 60px;
  line-height: 26px;
  border-radius: 6px;
  border: 1px solid rgba(73, 168, 200, 1);
  font-size: 14px;
  font-weight: 500;
  color: rgba(87, 174, 204, 1);
  text-align: center;
}
</style>
